import type { MeResponse } from "@/api/auth";

export function profileTitle(session: MeResponse): string {
  return session.user.display_name ?? session.user.email;
}
